/*
export const someMutation = (state) => {}
 */
export var setDrawerData = function setDrawerData(state, data) {
  state.data = data;
};
export var clearDrawerData = function clearDrawerData(state, data) {
  state.data = data;
};